import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsCycleTimeClassicRoute: InvariantJiraRoute = {
	name: 'software-reports-cycle-time-classic',
	path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
	exact: true,
};
